import { useEffect, useState, createRef } from 'react'
import axios from 'axios'
import { SearchResponseModel } from '@/types/backend'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'


const pageCountEndpoint = 'Umbraco/api/Search/saveSearchPageCount';

export const HeaderSearch = () => {

	const [isSearchOpen, setIsSearchOpen] = useState(false)
	const [searchTerm, setSearchTerm] = useState('')
	const [searchResults, setSearchResults] = useState<SearchResponseModel[]>([])
	const [isLoading, setIsLoading] = useState(false)
	const rootRef = createRef<HTMLDivElement>()

	const getSearchResults = async (query: string) => {
		if (isLoading) { return; }

		setIsLoading(true);
		try {
			let endpoint = '';

			if (query.trim() === '') {
				endpoint = '/Umbraco/api/Search/GetTopPages';
			} else {
				endpoint = '/Umbraco/api/Search/SearchByText';
			}

			const requestBody = query.trim() === '' ? null : {
			Query: query,
			Filters: [],
			Categories: []
			};

			const requestConfig = {
			method: query.trim() === '' ? 'GET' : 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: query.trim() === '' ? null : JSON.stringify(requestBody)
			};

			const response = await fetch(endpoint, requestConfig);

			const responseBody = await response.json();
			setSearchResults(responseBody);
			setIsLoading(false);
		} catch (error: any) {
			setIsLoading(false);
			console.log(error.message);
		}
	};

	const handleItemClick = async (
		evt: React.MouseEvent<HTMLAnchorElement>,
		url: string,
		id: number,
	) => {
		evt.preventDefault();

		const baseUrl = window.location.origin
		const requestUrl = `${baseUrl}/${pageCountEndpoint}`;

		const response = await axios.post(requestUrl, { pageId: id });

		if (response.data) {
			window.location.href = url;
		}
	};

	useEffect(() => {
		if(isSearchOpen) {
			document.body.classList.add('overflow-hidden')
			rootRef.current?.closest('.group')?.classList.add('header-search-open')
		} else {
			document.body.classList.remove('overflow-hidden')
			rootRef.current?.closest('.group')?.classList.remove('header-search-open')
		}
	}, [isSearchOpen])

	useEffect(() => {
		if (searchTerm.length > 0) {
			const getData = setTimeout(() => {
				getSearchResults(searchTerm);
			}, 400);

			return () => clearTimeout(getData);
		} else {
			// If searchTerm is empty, call the endpoint for top pages
			getSearchResults('');
		}
	}, [searchTerm]);


	return (
		<div ref={rootRef}>
			<button
				className="flex items-center mr-2.5 lg:mr-0"
				type="button"
				onClick={() => setIsSearchOpen(!isSearchOpen)}
			>
				{isSearchOpen ? (
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="21"
						viewBox="0 0 20 21"
						fill="none"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M4.41205 4.91074C4.73748 4.5853 5.26512 4.5853 5.59056 4.91074L10.0013 9.32149L14.412 4.91074C14.7375 4.58531 15.2651 4.58531 15.5906 4.91074C15.916 5.23618 15.916 5.76382 15.5906 6.08925L11.1798 10.5L15.5906 14.9107C15.916 15.2362 15.916 15.7638 15.5906 16.0893C15.2651 16.4147 14.7375 16.4147 14.412 16.0893L10.0013 11.6785L5.59056 16.0893C5.26512 16.4147 4.73748 16.4147 4.41205 16.0893C4.08661 15.7638 4.08661 15.2362 4.41205 14.9107L8.82279 10.5L4.41205 6.08925C4.08661 5.76382 4.08661 5.23618 4.41205 4.91074Z"
							fill="white"
						/>
					</svg>
				) : (
					<svg
						className="inline-block"
						xmlns="http://www.w3.org/2000/svg"
						width="20"
						height="21"
						viewBox="0 0 20 21"
						fill="none"
					>
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M8.33366 3.83333C5.57224 3.83333 3.33366 6.07191 3.33366 8.83333C3.33366 11.5948 5.57224 13.8333 8.33366 13.8333C11.0951 13.8333 13.3337 11.5948 13.3337 8.83333C13.3337 6.07191 11.0951 3.83333 8.33366 3.83333ZM1.66699 8.83333C1.66699 5.15143 4.65176 2.16666 8.33366 2.16666C12.0156 2.16666 15.0003 5.15143 15.0003 8.83333C15.0003 10.3739 14.4778 11.7925 13.6002 12.9214L18.0896 17.4107C18.415 17.7362 18.415 18.2638 18.0896 18.5893C17.7641 18.9147 17.2365 18.9147 16.9111 18.5893L12.4217 14.0999C11.2928 14.9774 9.87425 15.5 8.33366 15.5C4.65176 15.5 1.66699 12.5152 1.66699 8.83333Z"
							fill="white"
						/>
					</svg>
				)}
				<span className="lg:ml-2.5 text-[15px] text-btn-light-link-text lg:text-white font-medium lg:font-semibold hidden lg:inline-block">
					Search
				</span>
			</button>
			{isSearchOpen && (
				<div className="text-text-primary absolute top-full left-0 z-50 bg-white w-full h-[calc(100vh-55px)]">
					<div className="px-0 py-4 lg:p-8 border-b border-border-primary mb-8">
						<div className="container flex items-center">
							<svg
								width="24"
								height="24"
								viewBox="0 0 24 24"
								fill="none"
							>
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.551 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9056 16.3199C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z"
									fill="#272727"
								/>
							</svg>
							<input
								className="block w-full ml-2 lg:ml-3 px-3"
								type="text"
								placeholder="What are you searching for?"
								value={searchTerm}
								onInput={(e) =>
									setSearchTerm(e.currentTarget.value)
								}
							/>
						</div>
					</div>
					<div className="container">
						{searchTerm.length > 0 &&
						searchResults.length == 0 &&
						!isLoading ? (
							<div>No results found</div>
						) : (
							<>
								<div className="grid grid-cols-2 sm:grid-cols-4 gap-4 lg:gap-8">
								{isLoading ? (
									// Render skeleton components when loading
									Array.from({ length: 4 }).map((_, index) => (
									<div key={index} className="text-left">
										<Skeleton height={200} />
										<Skeleton height={20} width={150} className="mt-2" />
									</div>
									))
								) : (
									searchResults.slice(0, 4).map((item) => (
										<a
											key={item.id}
											href={item.url}
											className="text-left"
											onClick={(e) =>
												handleItemClick(e, item.url, item.id)
											}
										>
											<div className="rounded-lg overflow-hidden pb-16/9 relative h-0 w-full">
											<img
													className="block w-full absolute top-0 left-0 h-full object-cover"
													src={`${item.imageUrl}&width=400&height=300`}
													alt={item.imageAltText}
												/>
											</div>
											<div className="mt-2 text-body-sm-m lg:text-body-sm font-bold text-text-heading">
												{item.name}
											</div>
										</a>
									))
								)}
								</div>
								{searchResults.length > 0 && (
									<div className="mt-8">
										<a
											href={`/search?query=${searchTerm}`}
											className="py-3 px-8 w-full sm:w-auto border-2 border-btn-light-secondary-border rounded-full text-button-md font-bold text-text-heading hover:border-btn-light-secondary-text-hover hover:border-btn-light-secondary-border-hover"
										>
											See all results
										</a>
									</div>
								)}
							</>
						)}
					</div>
				</div>
			)}
		</div>
	)
}

export default HeaderSearch
